export default __webpack_public_path__ + "static/media/OrangeIndicator.1fed97be.jpg";